<template>
  <CContainer :fluid="true">
    <CRow>
      <CCol md="12" class="bg-white d-flex justify-content-center pt-0 pt-md-1">
        <div
          v-if="stats"
          class="passes-stats-container d-flex align-items-center justify-content-between px-2 px-sm-4"
        >
          <div class="passes-stats pt-2 pt-sm-0">
            <BuildingPasses />
            <MyPasses />
            <FlaggedPasses />
            <div
              v-if="stats.autoPassesRoomsCount"
              class="stat inverse icon-appended"
              tabindex="0"
              :aria-label="autoPassesStatusLabel"
              @keydown.enter.prevent="openCreateAutoPassLimit"
            >
              <div class="stat-content">
                Auto Passes
                <span>{{
                  stats.autoPassLimit
                    ? stats.autoPassesPreferencesCount +
                      " out of " +
                      stats.autoPassesRoomsCount
                    : "Off"
                }}</span>
              </div>
              <div class="icon" @click="openCreateAutoPassLimit">
                <i class="flaticon-pen-1"></i>
              </div>
            </div>
            <div
              v-if="isActiveKioskModule"
              class="open-kiosk d-flex align-items-center ms-4"
            >
              <span class="stats-title me-2 ms-2">Kiosk:</span>
              <div class="icon">
                <i class="fi flaticon-monitor"></i>
                <span>{{ stats.myOpenKiosksCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import BuildingPasses from "@/v3components/Dashboard/BuildingPassesOld.vue"
import FlaggedPasses from "@/v3components/Dashboard/FlaggedPassesOld.vue"
import MyPasses from "@/v3components/Dashboard/MyPassesOld.vue"
import CreateAutoPassLimit from "@/v3components/Forms/CreateAutoPassLimit.vue"
import { computed, inject, onMounted, reactive } from "vue"
import useAppToast from "@/composables/useAppToast"
import { useStore } from "vuex"

export default {
  name: "DashboardCountersOld",
  components: {
    BuildingPasses,
    MyPasses,
    FlaggedPasses
  },
  setup() {
    const toast = useAppToast()
    const store = useStore()
    const modal = inject("modal")

    const state = reactive({
      activePassLimit: null
    })

    const isActiveAppoinmentModule = computed(
      () => store.getters["schools/isActiveAppoinmentModule"]
    )

    const isActiveKioskModule = computed(
      () => store.getters["schools/isActiveKioskModule"]
    )

    const stats = computed(() => store.getters["dashboardTable/stats"])
    const autoPassesStatusLabel = computed(() => {
      if (!stats.value?.autoPassesRoomsCount) return "Auto Passes"
      if (!stats.value?.autoPassLimit) return "Auto Passes Off"

      return `Auto Passes ${stats.value?.autoPassesPreferencesCount || 0} out of ${stats.value?.autoPassesRoomsCount || 0}`
    })

    const fetchAllPassesForCounter = async () => {
      try {
        await store.dispatch("dashboardCounters/getPassesForCounters")
      } catch {
        toast.error(
          "Shucks! Something went wrong while fetching building passes data."
        )
      }
    }

    onMounted(async () => {
      fetchAllPassesForCounter()
    })

    const openCreateAutoPassLimit = () => {
      modal.open(CreateAutoPassLimit, {
        size: "lg",
        title: "Set Auto Pass limit",
        help: "auto_pass_limit",
        isHelpOld: true,
        props: {
          limit: stats.value.autoPassLimit
            ? stats.value.autoPassLimit.limit
            : null
        }
      })
    }

    return {
      state,
      isActiveAppoinmentModule,
      isActiveKioskModule,
      stats,
      autoPassesStatusLabel,
      openCreateAutoPassLimit
    }
  }
}
</script>
